export enum GIFData_GIFType {
  NORMAL = 'NORMAL',
  STICKER = 'STICKER',
  UNRECOGNIZED = 'UNRECOGNIZED',
}